// Practice location — schemas + inferred types.
//
// Second Zod-in-types migration (after labValue).
//
// Consumers can:
//   - import { PracticeLocation, PracticeLocationType } for compile-time typing
//   - import { PracticeLocationSchema, PracticeLocationTypeSchema } for
//     runtime validation of API responses / form input
//
// The backend projects Firestore documents through PracticeLocationSchema.safeParse in
// routes/practiceLocations.ts and drops any that do not fit.

import { z } from 'zod';

export const PRACTICE_LOCATION_TYPES = [
  'medical_school',
  'training_program',
  'practice_location',
] as const;

export const PracticeLocationTypeSchema = z.enum(PRACTICE_LOCATION_TYPES);
export type PracticeLocationType = z.infer<typeof PracticeLocationTypeSchema>;

export const PracticeLocationSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  type: PracticeLocationTypeSchema.optional(),
  specialty: z.string().optional(),
});

export type PracticeLocation = z.infer<typeof PracticeLocationSchema>;
